var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagBarbados(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_14971)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9565 1.58763C20.853 0.5705 18.4931 0 16 0C13.5069 0 11.147 0.5705 9.0435 1.58763L7.65219 16L9.0435 30.4124C11.147 31.4295 13.5069 32 16 32C18.4931 32 20.853 31.4295 22.9565 30.4124L24.3478 16L22.9565 1.58763Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.0435 1.58813C3.69163 4.17601 0 9.65657 0 15.9999C0 22.3433 3.69163 27.8239 9.0435 30.4118V1.58813Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9561 1.58813V30.4118C28.3079 27.8239 31.9996 22.3433 31.9996 15.9999C31.9996 9.65664 28.3079 4.17601 22.9561 1.58813Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8695 9.73921L21.8029 10.2058L20.8695 9.73921L19.9362 9.27259C19.8799 9.38515 18.6612 11.8647 18.4622 15.6523H17.0435V9.73921L16 8.3479L14.9565 9.73921V15.6523H13.5378C13.3387 11.8647 12.1201 9.38515 12.0637 9.27259L10.1971 10.2059C10.21 10.2315 11.4783 12.8131 11.4783 16.6958V17.7393H14.9565V23.6523H17.0435V17.7393H20.5217V16.6957C20.5217 14.6883 20.8691 13.0331 21.1605 11.998C21.4782 10.8692 21.8009 10.21 21.804 10.2035L20.8695 9.73921Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_14971"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagBarbados);
export default __webpack_public_path__ + "static/media/flag_barbados.21c84ce5af35a72e668c1dc6e1fa6cdc.svg";
export { ForwardRef as ReactComponent };